import { render, staticRenderFns } from "./materDispose.vue?vue&type=template&id=9a3b9ef4&"
import script from "./materDispose.vue?vue&type=script&lang=js&"
export * from "./materDispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports